import { faCapsules } from '@fortawesome/pro-regular-svg-icons/faCapsules'
import { faCircleX } from '@fortawesome/pro-regular-svg-icons/faCircleX'
import { faPills } from '@fortawesome/pro-regular-svg-icons/faPills'
import type { BackgroundColor, TextColor } from '@lib/colors/colors'
import properCase from '@lib/utilities/text/properCase'
import some from 'lodash/some'
import { DetailPill } from './DetailPill'

export function KeyEligibilityCriteria({
  medicationsDisqualifyingParticipation,
  medicationsRequiredForParticipation,
  participationDisqualifiers,
}: {
  medicationsDisqualifyingParticipation?: string
  medicationsRequiredForParticipation?: string
  participationDisqualifiers?: string
}) {
  const participationDisqualifiersOrFallback =
    participationDisqualifiers ?? 'Not Listed'

  const hasEligibilityCriteria = some([
    participationDisqualifiersOrFallback,
    medicationsRequiredForParticipation,
    medicationsDisqualifyingParticipation,
  ])

  if (!hasEligibilityCriteria) {
    return null
  }

  return (
    <div className='hidden w-full select-none lg:block'>
      <p className='text-xs font-semibold leading-normal text-neutral500 antialiased'>
        Key Eligibility Criteria
      </p>
      <div className='mt-2 flex flex-wrap gap-2'>
        {[
          {
            bgColor: 'bg-warm50',
            icon: faCircleX,
            iconColor: 'text-warm600',
            key: 'disqualifiers',
            prefix: 'Disqualifiers',
            value: properCase(participationDisqualifiersOrFallback),
          },
          {
            bgColor: 'bg-blue50',
            icon: faCapsules,
            iconColor: 'text-blue500',
            key: 'required-meds',
            prefix: `Must Be Taking`,
            value: properCase(medicationsRequiredForParticipation ?? ''),
          },
          {
            bgColor: 'bg-blue50',
            icon: faPills,
            iconColor: 'text-blue500',
            key: 'disqualifying-meds',
            prefix: `Must Not Be Taking`,
            value: properCase(medicationsDisqualifyingParticipation ?? ''),
          },
        ]
          .filter((item) => item.value && item.value !== '')
          .slice(0, 2)
          .map((item) => (
            <DetailPill
              bgColor={item.bgColor as BackgroundColor}
              icon={item.icon}
              iconColor={item.iconColor as TextColor}
              key={item.key}
              prefix={item.prefix}
              value={item.value}
            />
          ))}
      </div>
    </div>
  )
}
